<template>
	<button
		:class="`landing-language-button_${color}`"
		class="landing-language-button"
		@click="handleClick"
		type="button"
	>
		<!-- Globe Icon from lang-icon.svg -->
		<svg
			class="landing-language-button__icon"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"
				fill="currentColor"
			/>
		</svg>
		<span class="landing-language-button__text">{{ currentLanguageCode }}</span>
	</button>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
	name: 'LandingLanguageButton',

	props: {
		color: {
			type: String,
			default: 'primary',
			validator: (value) => ['primary', 'white'].includes(value),
		},
	},

	computed: {
		...mapGetters({
			language: 'i18n/getLanguage',
			getQueryParam: 'location/getQueryParam',
		}),

		currentLanguage() {
			return this.getQueryParam('lang') || this.language || 'en'
		},

		currentLanguageCode() {
			return this.currentLanguage.split('-')[0].toUpperCase()
		},

		screenName() {
			// Для лендингов всегда OnboardingWelcomeScreen
			return 'OnboardingWelcomeScreen'
		},
	},

	methods: {
		...mapMutations({
			setLanguageModalState: 'setLanguageModalState',
		}),

		handleClick() {
			this.setLanguageModalState({ showModal: true, screenName: this.screenName })
		},
	},
}
</script>

<style scoped lang="scss">
.landing-language-button {
	position: absolute;
	top: var(--size-18);
	right: var(--size-24);
	z-index: 1;
	display: flex;
	align-items: center;
	padding: 0;
	gap: var(--size-4);
	border: none;
	background: transparent;
	color: var(--Text-Primary-100);
	cursor: pointer;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.8;
	}

	&:active {
		opacity: 0.6;
	}

	&__icon {
		width: var(--size-24);
		height: var(--size-24);
		flex-shrink: 0;
	}

	&__text {
		font-weight: 600;
		font-size: var(--size-16);
		line-height: 1.25;
		color: var(--Text-Primary-100);
	}

	&_white {
		.landing-language-button__icon {
			path {
				fill: var(--Fill-White);
			}
		}
		.landing-language-button__text {
			color: var(--Text-White-100);
		}
	}
}
</style>
